import { useState } from 'react';
import { Button } from '@/features/button';
import { IconArrowSquareDown, IconArrowSquareUp } from '@/features/icons';
import { useMobileDetect } from '@/features/mobile-detect-context/mobile-detect-provider';
import { cn } from '@/utils/cn';
import { useLanguage } from '../../context/language-context-provider';
const TeamStatistics = () => {
  const {
    isMobile
  } = useMobileDetect();
  const [isShowFullContent, setIsShowFullContent] = useState(false);
  const {
    t
  } = useLanguage();
  return <>
            <div className='flex flex-col items-center justify-center gap-6 py-5.5 lg:py-6'>
                <div className='item'>
                    <span className='title'>{t('statistics.team.body.title')}</span>
                    <span className='value'>{t('statistics.team.body.text')}</span>
                </div>
                <div className='relative'>
                    <span className={cn('value inline-block overflow-hidden px-2', {
          'h-56': !isShowFullContent && isMobile,
          'pb-2': isShowFullContent && isMobile
        })}>
                        {t('statistics.team.body.description')}
                    </span>

                    {!isShowFullContent && isMobile && <div className='absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-white to-transparent' />}
                </div>
            </div>

            {isMobile && <Button graphicStyle='text' size='small' onClick={() => setIsShowFullContent(prev => !prev)} className='absolute bottom-4 right-1/2 translate-x-1/2' icon={{
      element: isShowFullContent ? <IconArrowSquareUp className='h-6 w-6' /> : <IconArrowSquareDown className='h-6 w-6' />,
      position: 'left'
    }}>
                    {t(isShowFullContent ? 'general.showLess' : 'general.showMore')}
                </Button>}
        </>;
};
export default TeamStatistics;